/**
 * Created by piotr.pozniak@thebeaverhead.com on 13/10/2018.
 */

import React from "react";
import { formatDate } from "../../../../helpers/date";

/**
 * @param {Object} props
 * @param {Object} props.currentDate
 * @param {Boolean} props.show - whether the label should render at all
 * @param {Array} props.events - events collection for the current view
 * @param {Boolean} [props.showDayName=false] - append the weekday name to the label
 * @param {Boolean} [props.showUpcomingNavigation=false] - derive the range from the events collection instead of currentDate
 * @param {String} props.eventsNumberOption
 */
const CalendarHeaderLabel = ({
  currentDate,
  show,
  events,
  showDayName = false,
  showUpcomingNavigation = false,
  eventsNumberOption,
}) => {
  if (!show) {
    return null;
  }

  const showNavigation = ["upcoming", "all"].indexOf(eventsNumberOption) >= 0;

  let headerTitle = formatDate(currentDate, {
    month: "long",
    year: "numeric",
  });

  if (!showNavigation || showUpcomingNavigation) {
    const firstEventDate = events.length
      ? new Date(events[0].start_time * 1000)
      : currentDate;

    const lastEventDate = events.length
      ? new Date(events[events.length - 1].start_time * 1000)
      : currentDate;

    const fromMonth = formatDate(firstEventDate, { month: "long" });
    const fromYear = formatDate(firstEventDate, { year: "numeric" });
    const toMonth = formatDate(lastEventDate, { month: "long" });
    const toYear = formatDate(lastEventDate, { year: "numeric" });

    if (fromYear !== toYear) {
      headerTitle = `${fromMonth} ${fromYear} - ${toMonth} ${toYear}`;
    } else if (fromMonth !== toMonth) {
      headerTitle = `${fromMonth} - ${toMonth} ${fromYear}`;
    } else {
      headerTitle = `${fromMonth} ${fromYear}`;
    }
  }

  if (showDayName) {
    headerTitle += " - " + formatDate(currentDate, { weekday: "long" });
  }
  //const header = showMonthHeader ?  : null;
  return <h2 className="dce__h1">{headerTitle}</h2>;
};

export default CalendarHeaderLabel;
